<template lang="pug">
  main.app-content.container
    .job-search
      h3 ค้นหาตำแหน่งงานของคุณ
      search-nav(@eventTabChange="onTabChange")

      .search-form
        search-basic(v-if="active === 'basic'")
        search-advanced(v-if="active === 'advanced'")

    .job-search-result
      job-item(
        v-for="(job, index) in jobs"
        :key="index"
        :job="job"
      )

      .text-center
        .spinner-border.text-primary(v-if="isLoading")
        br
        button.job-viewmore(
          @click="fetchData(true)"
          :disabled="isLoading"
        ) 
          | ดูตำแหน่งงานเพิ่มเติม
          .rippleJS
        
  </main>
</template>

<script>
import axios from 'axios'
import SearchNav from '../components/SearchNav.vue'
import SearchBasic from '../components/SearchBasic.vue'
import SearchAdvanced from '../components/SearchAdvanced.vue'

import JobItem from '../components/JobItem.vue'
export default {
  components: { SearchNav, SearchBasic, SearchAdvanced, JobItem },
  data: () => ({
    active: 'basic',
    jobs: [],
    query: {},
    isLoading: false
  }),

  mounted() {
    this.fetchData()
  },

  methods: {
    onTabChange(val) {
      this.active = val
    },

    fetchData(loadMore = false) {
      this.isLoading = true

      // console.log(Object.assign({}, this.query))
      axios
        .get(`${THAIRUNG.api_endpoint}thairung/job`, {
          params: this.query
        })
        .then(({ data }) => {
          if (loadMore) {
            this.jobs.push(...data.data)
          } else {
            this.jobs = data.data 
          }

          this.meta = data.meta
        })
        .catch(error => {
        })
        .then(()=> {
          this.isLoading = false
        })
    }
  }
}
</script>